import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

const NotFound = ({ hiddenButton, customHint, icon }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`notFound.${key}`);
  const navigate = useNavigate();
  return (
    <section className="py-[20px] flex flex-col items-center justify-center w-full">
      <p className="font-medium mb-[10px] text-2xl text-transaction-text dark:text-base-light-white tracking-tight">
        {i18n("nothingFound")}
      </p>
      {icon && (
        <div className="text-[50px]  text-transaction-text dark:text-base-light-white mb-[10px]">
          {icon}
        </div>
      )}
      <p className="text-transaction-text dark:text-base-light-white text-center">
        {customHint ? customHint : i18n("transactionHint")}
      </p>
      {hiddenButton || (
        <button
          type="button"
          onClick={() => navigate("/")}
          className="p-[15px] font-medium rounded-full text-light-white bg-main-color"
        >
          {i18n("placeBetHint")}
        </button>
      )}
    </section>
  );
};

export default NotFound;
